namespace $.$$ {
	export class $shm_hitalama_profile_quick extends $.$shm_hitalama_profile_quick {

		profile() {
			return this.$.$shm_hitalama_profile.current()
		}

		@ $mol_mem
		ids_ordered( next?: string[] ) {
			return this.profile()?.bottom_quick_access_ordered( next ) ?? next ?? this.ids()
		}

		@ $mol_mem
		ids() {
			return this.profile()?.bottom_quick_access_items().map( item => item.id ) ?? []
		}

		@ $mol_mem_key
		widget( id: string ) {
			return $giper_baza_glob.Pawn( new $giper_baza_link( id ), $shm_hitalama_map_widget )
		}

		@ $mol_mem_key
		item( id: string ) {
			return this.widget( id )
		}

		@ $mol_action
		open( id: string ) {
			const uri = this.$.$mol_state_arg.link({ fullscreen_widget: id })
			this.$.$mol_state_arg.href( uri )
		}

		@ $mol_action
		close() {
			const uri = this.$.$mol_state_arg.link({ fullscreen_widget: null })
			this.$.$mol_state_arg.href( uri )
		}

		@ $mol_mem
		checked_id(): string {
			return this.$.$mol_state_arg.value( 'fullscreen_widget' ) ?? ''
		}

		@ $mol_mem_key
		checked( id: any, next?: boolean ): boolean {
			if( next !== undefined ) {
				if( !this.drag_pan( id ) ) {
					if( next == false ) this.close()
					else this.open( id )
					return next
				}
			}

			return id == this.checked_id()
		}

		@ $mol_action
		item_remove( id: string ) {
			this.profile()?.bottom_quick_access_item_remove( id )
		}

		@ $mol_mem
		keydown_handler() {
			return $mol_wire_async( ( event: KeyboardEvent )=> {
				
				if( $shm_hitalama_is_input_focused() ) return

				const n = Number( event.key )
				if( !Number.isInteger( n ) ) return

				const id = this.ids_ordered().at( n - 1 )
				if( !id ) return
				if( id == this.checked_id() ) this.close()
				else this.open( id )

			} )
		}

	}
}
